module.exports = __webpack_public_path__ + "static/media/whatsap.6acaaf32.svg";